import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import FeaturedGuides from './components/FeaturedGuides';
import ArticleList from './components/ArticleList';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { HomeSEO } from '@/components/feature/SEOHead';

export default function Home() {
  return (
    <>
      <HomeSEO />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <AboutSection />
        <FeaturedGuides />
        <ArticleList />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}